import type { IconBaseProps } from "./Icon";

export default function ChevronDownIcon({ className, color, width, height }: IconBaseProps) {
  return (
    <svg
      className={className}
      style={{ color: color }}
      width={width ?? 14}
      height={height ?? 7}
      viewBox="0 0 14 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>Chevron Down</title>
      <path
        d="M13.1685 0.999999L7.16572 6L1.16299 1"
        stroke="currentColor"
        strokeWidth="0.75785"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
